<template>
  <div v-loading="loading" class="app-container">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="queryParams" @search="handleQuery" @reset="reset" />
    </el-card>
    <el-card>
      <div style="margin-bottom: 12px;">
        <el-button v-if="$btnsPermission('system:role:add')" type="primary" size="small" class="common-btn" @click="handleAdd">
          新增角色
        </el-button>
      </div>

      <el-table :data="roleList" :height="heightStyleObj" style="width: 100%" highlight-current-row border stripe>
        <el-table-column type="selection" />
        <el-table-column prop="roleName" label="角色名称" />
        <el-table-column prop="status" label="状态" width="160">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" active-color="#13ce66" active-value="0" inactive-value="1"
                       @change="changeStatus(row.roleId, $event)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column width="180" prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ parseTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="{ row }">
            <el-button v-if="$btnsPermission('system:role:edit')" type="text" @click="editRow(row)">
              修改
            </el-button>
            <el-button v-if="$btnsPermission('system:role:deleteTenantRole')" type="text" @click="deleteRow(row)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                  @pagination="getList" />
    </el-card>

    <EditRole v-if="roleShow" :visible="roleShow" :data="currentItem" :action="action" @close="roleShow = false" />
  </div>
</template>

<script>
import EditRole from './EditRole.vue'
import { listRole, changeRoleStatus, delRole } from '@/api/system/role.js'

export default {
  name: 'Role',
  components: { EditRole },
  data() {
    return {
      // 遮罩层
      loading: true,
      heightStyleObj: '',
      total: 0,
      queryItems: [
        {
          label: '角色名称',
          field: 'searchKey',
          type: 'input',
        },
        {
          label: '创建时间',
          field: 'createTime',
          type: 'date'
        },
        {
          label: '角色状态',
          field: 'status',
          type: 'select',
          options: [{
            dictLabel: '正常',
            dictValue: '0'
          }, {
            dictLabel: '停用',
            dictValue: '1'
          }],
        },
      ],
      roleList: [],
      // 弹出层标题
      title: '',

      roleShow: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        appId: '4',
        searchKey: '',
        status: '',
        createTime: []
      },
      dateRange: [],
      currentItem: null,
      action: 'add'
    }
  },
  created() {
    this.heightStyleObj = window.innerHeight - 425 + 'px'
    this.getList()
  },
  methods: {
    /** 查询角色列表 */
    getList() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.queryParams))
      if (params.createTime) {
        const [createTimeStart, createTimeEnd] = params.createTime
        params.createTimeStart = createTimeStart
        params.createTimeEnd = createTimeEnd
      }
      delete params.createTime
      listRole(params)
        .then((res) => {
          this.roleList = res.rows
          this.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
      this.roleList = []
    },

    changeStatus(roleId, status) {
      changeRoleStatus(roleId, status).catch(() => {
        const findIndex = this.roleList.findIndex((item) => item.roleId == roleId)
        this.$nextTick(() => {
          this.roleList[findIndex].status = status == '0' ? '1' : '0'
        })
      })
    },

    reset() {
      this.queryParams = Object.assign(this.$data.queryParams, this.$options.data.call(this)).queryParams
      this.getList()
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.roleShow = true
      this.action = 'new'
      this.currentItem = {}
    },

    editRow(row) {
      this.roleShow = true
      this.currentItem = JSON.parse(JSON.stringify(row))
      this.action = 'edit'
    },

    /** 删除按钮操作 */
    deleteRow(row) {
      this.$confirm(`确定删除角色 ${row.roleName}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delRole(row.roleId)
          .then((res) => {
            this.loading = true
            const { code, msg } = res
            if (code === 200) {
              this.$message({
                message: '删除角色成功!',
                type: 'success'
              })
              this.getList()
            } else {
              this.$message.error(msg)
            }
          })
          .catch((err) => {
            // // this.$message.error(err)
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>
